import React from 'react'
import { PLACEHOLDER_IMAGE_BYTES } from './helpers/PlaceholderImageConstant'

class LeftBarSlides extends React.Component {
    viewSlide = (event) => {
        event.preventDefault()

        this.props.viewSlide(event.target.dataset.id)
    }

    handleDivNames = (id) => {
        return (this.props.slide && id === this.props.slide.slideNumber) ? 'slideThumbnail active' : 'slideThumbnail'
    }

    render() {
        return (
            <ul>
                {this.props.slides && this.props.slides.length > 0 && this.props.slides[0].slideImage !== null && this.props.slides.sort(function (a, b) { return a["slideNumber"] - b["slideNumber"] }).map((x, i) =>
                    {
                        const isActive = this.props.slide && x.slideNumber === this.props.slide.slideNumber;
                        const activeStyle = isActive ?  {backgroundColor:'#CBDEF4'} : {};
                        let useNullClass = x.slideImage.imageBytes === null
                        let imageBytes = x.slideImage.imageBytes === null ? PLACEHOLDER_IMAGE_BYTES : x.slideImage.imageBytes
                        return (<li key={`left-hand-slide-${i}`} style={activeStyle}>
                            <img src={`data:image/jpeg;base64,${imageBytes}`} alt={i} width="180" height="115" onClick={this.viewSlide} data-id={x.slideNumber} className={useNullClass ? 'loading' : ''} />
                        </li>);
                    }
                )}
            </ul>
        )
    }
}

export default LeftBarSlides